import Vue from "vue";
import Vuex from "vuex";
import program from "./program";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    program,
  },
});
